/* eslint-disable no-use-before-define */
import React from 'react'
import { hideModal, show, isEmpty } from '../twd'
import { useCalculator, STEPS } from './use-calculator'

export const NextStep= () => {

    const { cusip, calcOutput, step, from_ } = useCalculator()

    const isShow = !isEmpty(calcOutput)
        && step===STEPS.CALC_OUTPUT
    if (!isShow) return null


    return  <React.Fragment>
        <div className='row'>
        <div className='col-md-12 col-xs-12'>
            <h3 className='small-header' style={{margin:0}}>Next Steps</h3>
        </div>
        </div>

        <div className='row vertical-offset-base'>
        <div className='col-xs-12 card-group'>
        <div
            className='card card-primary flex-md-6 flex-xs-12'
            style={{cursor:'pointer', marginLeft:0}}
            onClick={() => {
                hideModal()
                show('bond-detail', { cusip, from:from_ })
            }}
        >
        <div className='card-body'>
            <h3 className='card-title'>
                Take a closer look
            </h3>
            <div className='vertical-offset-base'>
                Review the detailed terms and features of this security.
            </div>
            <button className='btn btn-link'>
                View bond offering detail
            </button>
        </div>
        </div>
        </div>
        </div>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/calculator/next-step.js